/*
 * AFFICHAGE DES TABLEAUX SUR MOBILE - NB THEME
 * Auteur : Nicolas Blandel - nicoblandel.fr
 * Fonctionne sur une struture :
 * table
      > thead
      > tbody
 */

$(document).ready( function() {
  if ( $(".entry-content table").length &&	$(document).width() < 820 ) {
    $(".entry-content table").each( function() {
      if ( $(this).find("thead").length ) {
        // On récupère les titres des colonnes
        var tabTitles = new Array();
        var trhead = $(this).find("thead tr");
        trhead.find("td").each( function() {
          tabTitles.push( $(this).html() );
        });

        // On répercute les titres sur chaque ligne suivante
        $(this).find("tbody tr").each( function() {
          var i = 0;
          $(this).find("td").each( function() {
            if ( tabTitles[i].length && $(this).text().length ) {
              $(this).prepend("<strong>"+tabTitles[i]+" :</strong> ");
            }
            else {
              $(this).addClass("hideTd");
            }
            i++;
          });
        });
      }
    });
  }
});
